import { FC, useEffect, useMemo } from "react";
import { observer } from "mobx-react";

import BarChartCard from "./BarChartCard";
import { useObservabilityStore } from "../../../../hooks/useObservabilityStore";

const formatCount = (value: number): string => value.toLocaleString();

const CasesByUserBar: FC = observer(() => {
  const { isCasesBreakdownLoading, casesBreakdown, loadCasesBreakdown } =
    useObservabilityStore();

  useEffect(() => {
    loadCasesBreakdown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const bars = useMemo(
    () =>
      (casesBreakdown?.by_user ?? [])
        .map((row) => ({ name: row.user_displayName, value: row.cases }))
        .sort((a, b) => b.value - a.value),
    [casesBreakdown?.by_user],
  );

  return (
    <BarChartCard
      title="Cases by User"
      bars={bars}
      formatValue={formatCount}
      csvFilename="cases-by-user"
      csvValueHeader="Cases"
      emptyMessage="No user data available"
      isLoading={isCasesBreakdownLoading}
    />
  );
});

export default CasesByUserBar;
